import types from '../types'
import 'firebase/compat/auth'
import 'firebase/compat/database'
import {getAuthKey} from './getAuthKey'
import {getOrgId} from './getOrgId'
import {getOrgPermissions} from './getOrgPermissions'

export const onSignInSuccess =
  (user, database) => async (dispatch) => {
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        isLoading: true,
      },
    })
    const orgId = await dispatch(getOrgId(database, user))
    // const modelMetaData = await dispatch(getModelMetaData(database, orgId))
    const authKey = await dispatch(getAuthKey(database, orgId))
    const orgPermissions = await getOrgPermissions(database, orgId)
    const hasData = orgId && authKey
    let isSignedIn = false
    let userMessage = ''
    if (hasData) {
      isSignedIn = true
    } else {
      userMessage = 'You do not appear to have a Lazarus Account. Reach out to your Lazarus Representative or reach out to us through lazarusai.com.'
    }
    dispatch({
      type: types.STORE_PAYLOAD,
      payload: {
        user,
        orgId: orgId,
        authKey: authKey,
        isLoading: false,
        isSignedIn,
        userMessage,
        notificationIcon: 'warning',
        notificationType: 3,
        canReportDemoBugs: orgPermissions?.canReportDemoBugs,
        canUseBigFile: orgPermissions?.canUseBigFile,
      },
    })
  }

